'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../components');

var _iconsComponents = require('../../icons-components');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Footer component.
 * @param {FooterPropsType} props element
 * @returns {ReactElement} React element
 */
var FooterComponent = function (_React$Component) {
  (0, _inherits3.default)(FooterComponent, _React$Component);

  /**
   * Component constructor.
   *
   * @param {object} props element props
   * @public
   */
  function FooterComponent(props) {
    (0, _classCallCheck3.default)(this, FooterComponent);
    return (0, _possibleConstructorReturn3.default)(this, (FooterComponent.__proto__ || (0, _getPrototypeOf2.default)(FooterComponent)).call(this, props));
  }

  (0, _createClass3.default)(FooterComponent, [{
    key: 'render',


    /**
     * Render method for the component
     * @returns {Element<*>} the react element
     */
    value: function render() {
      var _props$t = this.props.t,
          t = _props$t === undefined ? function () {
        var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return function (msg) {
          return '' + ctx + msg;
        };
      } : _props$t;

      var text = t(_constants.TRANSLATION_CONTEXT)('FORM_LBL_FOOTER');

      return _react2.default.createElement(_components.Footer, { icon: _react2.default.createElement(_iconsComponents.PadlockIcon, null), text: text });
    }
  }]);
  return FooterComponent;
}(_react2.default.Component);

exports.default = FooterComponent;